module.exports = __webpack_public_path__ + "img/1.b6556080.png";